import { render, staticRenderFns } from "./WeChatCallbackView.vue?vue&type=template&id=ddb584aa&scoped=true&"
import script from "./WeChatCallbackView.vue?vue&type=script&lang=js&"
export * from "./WeChatCallbackView.vue?vue&type=script&lang=js&"
import style0 from "./WeChatCallbackView.vue?vue&type=style&index=0&id=ddb584aa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddb584aa",
  null
  
)

export default component.exports